import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 0;
  height: 100%;
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  border: none;
  background: transparent;
  color: #181818;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 0;
  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const SecondaryActionButton = styled.button`
  min-height: 38px;
  padding: 8px 20px;
  border: 1.5px solid #065fa6;
  border-radius: 6px;
  background: #ffffff;
  color: #065fa6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    border-color: #181818;
    color: #181818;
  }

  &:focus-visible {
    outline: 2px solid rgba(6, 95, 166, 0.2);
    outline-offset: 2px;
  }

  & i {
    font-size: 14px;
  }
`;

export const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 40px;
  min-height: 0;
  flex: 1 1 auto;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const ContentScroller = styled.div.attrs({
  "data-testid": "content-scroll",
} as Record<string, string>)`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & + & {
    margin-top: 48px;
  }
`;

export const SectionTitle = styled.h2`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const SectionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const DetailsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DetailsGroupTitle = styled.h3`
  color: #181818;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`;

export const RequestDetails = styled.div`
  border-top: 1px solid #e7e7e7;
`;

export const DetailRow = styled.div`
  display: grid;
  grid-template-columns: minmax(180px, 240px) minmax(0, 1fr);
  gap: 24px;
  padding: 18px 0;
  border-bottom: 1px solid #e7e7e7;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const DetailLabel = styled.div`
  color: #181818;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const DetailValue = styled.div`
  color: #181818;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const StatusValue = styled.div<{
  $status: "Draft" | "Completed" | "Cancelled";
}>`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #181818;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;

  &::before {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 999px;
    background: ${({ $status }) => {
      switch ($status) {
        case "Completed":
          return "#1fa971";
        case "Cancelled":
          return "#959595";
        default:
          return "#e6bd1a";
      }
    }};
  }
`;

export const EmptyState = styled.div`
  color: #5a5959;
  font-size: 14px;
  line-height: 20px;
`;
